import { Toolbar } from "primereact/toolbar";
import { ILogin, IPermissionProps } from "../../models/Login";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { IModal } from "./BlackListStatus";

export interface IBlackListStatusMast {
    blacklist_Status_ID?: number,
    blacklist_Status?: string,

};

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}

export const EmptyBlackListStatus = {
    blacklist_Status: "",
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const dt = useRef<any>(null);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const leftToolbarTemplate = () => {
        return (
            <div className="my-2">
                {props.permissions.is_Create && <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />}
            </div>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">BlackList Status</h5>
        </div>
    );

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyBlackListStatus });
    };
    const openEdit = (rowData: any) => {
        props.setModal({ open: true, singleData: rowData });
    };
    const action = (rowData: any) => {
        return (
            <div className="flex gap-3">
                {props.permissions.is_Update &&  <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>}
            </div>
        );
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("BlackList_Status_Mast", "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                value={tableData.tableData}
                resizableColumns showGridlines columnResizeMode="expand"
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="blacklist_Status" header="Status Name" />
                {props.permissions.is_Update  &&  <Column field="" header="Action" body={action} />}
            </DataTable>
        </>
    );
}